<template lang="html">
  <div class="full-page">
    <i-header
      title="投资者基本信息"
      @leftClick="$router.push({path: '/corporate/manager',query: {type: $route.query.type}})"
      >
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <div class="corporate-questions">
        <div class="corporate-questions-form">

          <div class="corporate-questions-form-item">
            <div class="corporate-questions-form-item-title">
              {{isFund ? '一、私募基金投资者，最近三个月月末资产均超过（含）人民币1000万元' :
              '一、资产管理计划投资者，为最近 1 年末净资产不低于 1000 万元的法人单位'}}
            </div>
            <div class="corporate-questions-form-item-content">
              <cube-validator
                ref="orgAssetsScale"
                v-model="result[1]"
                :model="Model.orgAssetsScaleChecked"
                :rules="Rules.orgAssetsScaleChecked"
                :messages="Messages.orgAssetsScaleChecked">
                <cube-radio-group
                  v-model="Model.orgAssetsScaleChecked"
                  :options="['是', '否']" :horizontal="true">
                </cube-radio-group>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
            </div>

          </div>

          <div class="corporate-questions-form-item">
            <div class="corporate-questions-form-item-title">
              二、是否为下列机构?<br/>
              符合《证券期货投资者适当性管理办法》第八条第（一）款所规定
              的证券公司、期货公司、基金管理公司及其子公司、商业银行、保
              险公司、信托公司、财务公司；或在中国证券投资基金业协会登记
              或者备案的证券公司子公司、期货公司子公司、私募基金管理人；或
              者第（三）款所规定的合格境外机构投资者（QFII),人民币合格境
              外机构投资者（RQFII)；或者第（四）款的规定，最近1年末净资产
              不低于2000万元，最近1年末金融资产不低于1000万元，具有2年以
              上证券、基金、期货、黄金、外汇等投资经历。
            </div>
            <div class="corporate-questions-form-item-content">
              <cube-validator
                ref="isProfessionalInvestors"
                v-model="result[0]"
                :model="Model.isProfessionalInvestorsChecked"
                :rules="Rules.isProfessionalInvestorsChecked"
                :messages="Messages.isProfessionalInvestorsChecked">
                <cube-radio-group
                  v-model="Model.isProfessionalInvestorsChecked"
                  :options="['是', '否']"
                  :horizontal="true">
                </cube-radio-group>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
            </div>
          </div>

          <div class="corporate-questions-form-item">
            <div class="corporate-questions-form-item-title">
              三、是否存在实际控制关系？
            </div>
            <div class="corporate-questions-form-item-content">
              <cube-validator
                ref="isControllingShareholder"
                v-model="result[2]"
                :model="Model.isControllingShareholderChecked"
                :rules="Rules.isControllingShareholderChecked"
                :messages="Messages.isControllingShareholderChecked">
                <cube-radio-group
                  v-model="Model.isControllingShareholderChecked"
                  :options="['是', '否']" :horizontal="true">
                </cube-radio-group>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
              <cube-validator
                v-if="Model.isControllingShareholderChecked === '是'"
                ref="isControllingShareholderDesc"
                v-model="result[3]"
                :model="Model.isControllingShareholderDescription"
                :rules="Rules.isControllingShareholderDescription"
                :messages="Messages.isControllingShareholderDescription">
                <cube-textarea
                  v-model="Model.isControllingShareholderDescription"
                  :indicator="false"
                  placeholder="请说明"
                  style="font-size:12px;">
                </cube-textarea>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
            </div>
          </div>

          <div class="corporate-questions-form-item">
            <div class="corporate-questions-form-item-title">
              四、交易实际受益人？
            </div>
            <div class="corporate-questions-form-item-content">
              <cube-validator
                ref="transactionActualBeneficiary"
                v-model="result[4]"
                :model="Model.transactionActualBeneficiaryChecked"
                :rules="Rules.transactionActualBeneficiaryChecked"
                :messages="Messages.transactionActualBeneficiaryChecked">
                <cube-radio-group
                  v-model="Model.transactionActualBeneficiaryChecked"
                  :options="['本机构', '其他机构或个人']" :horizontal="true">
                </cube-radio-group>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
              <cube-validator
                v-if="Model.transactionActualBeneficiaryChecked === '其他机构或个人'"
                ref="transactionActualBeneficiaryDesc"
                v-model="result[5]"
                :model="Model.transactionActualBeneficiaryDescription"
                :rules="Rules.transactionActualBeneficiaryDescription"
                :messages="Messages.transactionActualBeneficiaryDescription">
                <cube-textarea
                  v-model="Model.transactionActualBeneficiaryDescription"
                  :indicator="false"
                  placeholder="请说明"
                  style="font-size:12px;">
                </cube-textarea>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
            </div>

          </div>

          <div class="corporate-questions-form-item">
            <div class="corporate-questions-form-item-title">
              五、是否有不良诚信记录？
            </div>
            <div class="corporate-questions-form-item-content">
              <cube-validator
                ref="isBadFaith"
                v-model="result[6]"
                :model="Model.isBadFaithChecked"
                :rules="Rules.isBadFaithChecked"
                :messages="Messages.isBadFaithChecked">
                <cube-radio-group
                  v-model="Model.isBadFaithChecked"
                  :options="['是', '否']" :horizontal="true">
                </cube-radio-group>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
              <cube-validator
                v-if="Model.isBadFaithChecked === '是'"
                ref="isBadFaithDesc"
                v-model="result[7]"
                :model="Model.isBadFaithDescription"
                :rules="Rules.isBadFaithDescription"
                :messages="Messages.isBadFaithDescription">
                <cube-textarea
                  v-model="Model.isBadFaithDescription"
                  :indicator="false"
                  placeholder="请说明"
                  style="font-size:12px;">
                </cube-textarea>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
            </div>

          </div>
        </div>

        <div class="foot-btn">
          <cube-button @click="$_handleValidate">下一步</cube-button>
        </div>

      </div>
    </i-body>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import cmixin from '../../commonConfig';

export default {
  mixins: [cmixin],
  data() {
    return {
      result: [undefined, undefined, undefined, undefined, undefined, undefined],
      Model: {
        isProfessionalInvestorsChecked: null,
        orgAssetsScaleChecked: null,
        isControllingShareholderChecked: null,
        isControllingShareholderDescription: '',
        transactionActualBeneficiaryChecked: null,
        transactionActualBeneficiaryDescription: '',
        isBadFaithChecked: null,
        isBadFaithDescription: '',
      },
      Rules: {
        isProfessionalInvestorsChecked: {
          required: true,
        },
        orgAssetsScaleChecked: {
          required: true,
        },
        isControllingShareholderChecked: {
          required: true,
        },
        isControllingShareholderDescription: {
          required: true,
        },
        transactionActualBeneficiaryChecked: {
          required: true,
        },
        transactionActualBeneficiaryDescription: {
          required: true,
        },
        isBadFaithChecked: {
          required: true,
        },
        isBadFaithDescription: {
          required: true,
        },
      },
      Messages: {
        isProfessionalInvestorsChecked: {
          required: '请选择',
        },
        orgAssetsScaleChecked: {
          required: '请选择',
        },
        isControllingShareholderChecked: {
          required: '请选择',
        },
        isControllingShareholderDescription: {
          required: '请说明',
        },
        transactionActualBeneficiaryChecked: {
          required: '请选择',
        },
        transactionActualBeneficiaryDescription: {
          required: '请说明',
        },
        isBadFaithChecked: {
          required: '请选择',
        },
        isBadFaithDescription: {
          required: '请说明',
        },
      },
    };
  },
  computed: {
    ...mapGetters(['managerInfo', 'au', 'corporateInfo']),
    // 募集机构类型 orgType，fund:基金，futures：期货资管
    isFund() {
      return this.managerInfo.orgType !== 'futures';
    },
  },
  watch: {
    'Model.orgAssetsScaleChecked': {
      handler(val) {
        this.$_handleChedckedFirstToast(val);
      },
    },
    'Model.isProfessionalInvestorsChecked': {
      handler(val) {
        this.$_handleChedckedSecondToast(val);
      },
    },
  },

  mounted() {
    setTimeout(() => {
      this.$bridge.callHandler('getBaseInfo', { msg: '获取投资者基本信息' }, (data) => {
        const obj = JSON.parse(data);
        console.log('新增', obj);
        this.$_handlerInit(obj.baseInfo);
      });
    }, 300);
  },
  methods: {
    $_handlerInit(data) {
      const obj = JSON.parse(data);
      const models = ['isProfessionalInvestors', 'orgAssetsScale', 'isControllingShareholder', 'transactionActualBeneficiary', 'isBadFaith'];
      models.forEach((model) => {
        const value = JSON.parse(obj[model] || '{}');
        if (value) {
          if (value.checked) {
            this.Model[`${model}Checked`] = value.checked;
          }
          if (value.description) {
            this.Model[`${model}Description`] = value.description;
          }
        }
      });
    },
    /**
     * 表单校验
     * @return {[type]} [description]
     */
    $_handleValidate() {
      this.$nextTick(() => {
        let Refs = [];
        Refs = Object.keys(this.$refs).filter(item => this.$refs[item] !== undefined);
        Promise.all(Refs.map(key => this.$refs[key].validate())).then((valid) => {
          this.result = valid;
          if (valid.every(item => item)) {
            const selectModel = this.$_handlerFormatData();
            this.$store.dispatch('changeCorporateInfo', selectModel).then(() => {
              this.$_handlerSubmit();
            });
          }
        });
      });
    },
    $_handlerFormatData() {
      const selectModel = {
        isProfessionalInvestors: {
          checked: this.Model.isProfessionalInvestorsChecked,
        },
        orgAssetsScale: {
          checked: this.Model.orgAssetsScaleChecked,
        },
        isControllingShareholder: {
          checked: this.Model.isControllingShareholderChecked,
          description: this.Model.isControllingShareholderDescription,
        },
        transactionActualBeneficiary: {
          checked: this.Model.transactionActualBeneficiaryChecked,
          description: this.Model.transactionActualBeneficiaryDescription,
        },
        isBadFaith: {
          checked: this.Model.isBadFaithChecked,
          description: this.Model.isBadFaithDescription,
        },
      };
      return selectModel;
    },
    // 新增投资者提交
    $_handlerSubmit() {
      // 2022-12-08: ios偶发数据缓存丢失， 临时解决方案
      if (!this.corporateInfo.orgBusinessScope || !this.corporateInfo.representativeName) {
        this.$createDialog({
          type: 'clert',
          title: '提示',
          content: '缓存丢失，请重新填写',
          onConfirm: () => {
            this.$router.push({
              path: '/corporate',
              query: {
                type: this.$route.query.type,
              },
            });
          },
        }).show();
        return;
      }
      this.$bridge.callHandler('getResult', { msg: '新增投资者json', draftsNo: this.$route.query.draftsNo, json: JSON.stringify(this.corporateInfo) }, () => {
      });
    },
    /**
     * 第一题选项提示
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    $_handleChedckedFirstToast(val) {
      // 员工跟投、本机构问卷第一题不做限制, 可选是也可选否  --------- 2020.8.3 - 许静芸
      // SPECIFIC_PERSONAL_PRACTITIONERS_ORDINARY 特对对象认证-个人-管理从业人员-普通投资者
      // SPECIFIC_PERSONAL_PRACTITIONERS_PROFESSION 特对对象认证-个人-管理从业人员-专业投资者
      // SPECIFIC_ORG_PRACTITIONERS 特对对象认证-机构-从业人员
      if (['SPECIFIC_PERSONAL_PRACTITIONERS_ORDINARY', 'SPECIFIC_PERSONAL_PRACTITIONERS_PROFESSION', 'SPECIFIC_ORG_PRACTITIONERS']
        .includes(this.managerInfo.invenstemType)) {
        return;
      }
      // 可以选择“是”也可选择“否”，选择“否”提示用户流程不在继续，弹窗内容详见下方
      if (val === '否') {
        const str = this.isFund ? '私募基金应当向合格投资者募集，合格投资者应当满足《私募投资基金监督管理暂行办法》第12条以及《私募投资基金募集行为管理办法》第28条的规定，如您确认选“否”，则不符合合格投资者的相关规定，我们将终止向您募集资金，请确认是否更改选项？'
          : '资产管理计划应当向合格投资者非公开募集，合格投资者应当满足《证券期货经营机构私募资产管理计划运作管理规定》第三条的规定，如您确认选“否”，则不符合合格投资者的相关规定，我们将终止向您募集资金，请确认是否更改选项？';
        this.$createDialog({
          type: 'confirm',
          title: '提示',
          content: str,
          cancelBtn: {
            text: '确认选“否”',
          },
          confirmBtn: {
            text: '改为选“是”',
          },
          onConfirm: () => {
            this.$set(this.Model, 'orgAssetsScaleChecked', '是');
          },
          onCancel: () => {
            this.$router.back();
          },
        }).show();
      }
    },
    /**
     * 第二题选项提示
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    $_handleChedckedSecondToast(val) {
      // 若为专业投资者，但选项为“否”，需弹出如下操作确认弹窗
      // SPECIFIC_ORG_PROFESSION 特对对象认证-机构-专业法人及其他组织
      // SPECIFIC_ORG_ORG 特对对象认证-机构-金融投资机构
      // SPECIFIC_ORG_PRACTITIONERS 特对对象认证-机构-从业人员
      const isProfession = ['SPECIFIC_ORG_PROFESSION', 'SPECIFIC_ORG_ORG', 'SPECIFIC_ORG_PRACTITIONERS']
        .includes(this.managerInfo.invenstemType);
      if (isProfession && val === '否') {
        const str = `您的理财经理为您预设的投资者类型为专业投资者，
        根据《证券期货投资者适当性管理办法》第八条规定，专业投资者必须满足该条件，
        若您确认选“否”，我们将终止本投资者问卷的填写，请确认是否更改选项？`;
        this.$createDialog({
          type: 'confirm',
          title: '提示',
          content: str,
          cancelBtn: {
            text: '确认选“否”',
          },
          confirmBtn: {
            text: '改为选“是”',
          },
          onConfirm: () => {
            this.$set(this.Model, 'isProfessionalInvestorsChecked', '是');
          },
          onCancel: () => {
            this.$router.back();
          },
        }).show();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.corporate-questions {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .corporate-questions-form {
    .corporate-questions-form-item {
      padding: 16px;
      background: #fff;
      margin-bottom: 10px;
      .corporate-questions-form-item-title {
        font-size: 12px;
        margin-bottom: 8px;
        color: #666;
        line-height: 18px;
      }
      .corporate-questions-form-item-content {
        .cube-validator-msg-custom {
          font-size: 12px;
          color: red;
          margin-top: 5px;
        }
      }

    }
  }
}
</style>
